import React from "react";

export default function BashTool({ payload, result }) {
  const cmd = payload?.input?.command || "";
  const out = result?.content_preview || "";
  return (
    <div className="tool-card-body">
      <div className="tool-section">
        <h5>Command</h5>
        <pre className="tool-pre">$ {cmd}</pre>
      </div>
      {result && (
        <div className="tool-section">
          <h5>Output {result.is_error ? "(error)" : ""}</h5>
          <pre className="tool-pre">{out}</pre>
          {result.has_more && <div className="tool-truncated">…truncated. Click "Load full result" (coming).</div>}
        </div>
      )}
    </div>
  );
}
BashTool.summarize = (p) => p?.input?.command || "";
